"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const get_dsp_link_1 = require("@App/helpers/get-dsp-link");
const PointPreloader_1 = __importDefault(require("@App/kit/components/Preloaders/PointPreloader"));
const recording_1 = require("@App/api/routes/recording");
const DspDataSection_1 = __importDefault(require("./DspDataSection"));
const WritersSection_1 = __importDefault(require("./WritersSection"));
const RecordingDataSection_1 = __importDefault(require("./RecordingDataSection"));
const ReleaseDataSection_1 = __importDefault(require("./ReleaseDataSection"));
const react_router_dom_1 = require("react-router-dom");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RecordingDetails = () => {
    const params = (0, react_router_dom_1.useParams)();
    const [recordingData, setRecordingData] = (0, react_1.useState)();
    const [dspLink, setDspLink] = (0, react_1.useState)();
    const getRecordingDetails = (recordingId) => __awaiter(void 0, void 0, void 0, function* () {
        const ApiRecordingData = yield (0, recording_1.getDspRecordingDetails)(recordingId);
        return ApiRecordingData.data;
    });
    const initializeRecordingDetails = () => {
        const recordingId = params.recordingId;
        if (recordingId) {
            getRecordingDetails(recordingId).then((ApiRecordingData) => setRecordingData(ApiRecordingData));
        }
    };
    const initializeDspLink = () => {
        if (recordingData) {
            setDspLink((0, get_dsp_link_1.getDSPLink)(recordingData.dspMNumber, recordingData.dspReleaseId, recordingData.senderResourceId));
        }
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('recording_details');
        initializeRecordingDetails();
    }, []);
    (0, react_1.useEffect)(() => {
        initializeDspLink();
    }, [recordingData]);
    if (!recordingData) {
        return (react_1.default.createElement("div", { className: "loader-container" },
            react_1.default.createElement(PointPreloader_1.default, null)));
    }
    return (react_1.default.createElement("div", { className: "global-container" },
        react_1.default.createElement("main", { className: "recording-details-scene" },
            react_1.default.createElement("h3", null, recordingData.recordingTitle),
            react_1.default.createElement("p", null, "All recording data featured below has been provided to The MLC by the digital service provider (DSP) listed. The MLC does not have the ability to edit or change any of the information provided and does not assume responsibility for accuracy."),
            react_1.default.createElement(RecordingDataSection_1.default, { recordingData: recordingData }),
            react_1.default.createElement(WritersSection_1.default, { writers: recordingData.writers }),
            react_1.default.createElement(DspDataSection_1.default, { recordingData: recordingData, dspLink: dspLink }),
            react_1.default.createElement(ReleaseDataSection_1.default, { recordingData: recordingData }))));
};
exports.default = RecordingDetails;
